import { IScrBaseResponse } from "../services/base.service";



export class BadgeData {

  public shortCodeCount = 0;  // sum of needs action + transfers + monthly invoice
  public orderCount = 0; // sum of needs payment and monthly invoices

  public unreadMessageCount = 0;
  public needsPaymentCount = 0; // billing
  public needsActionCount = 0;   // my short codes
  public transfersCount = 0;  // my short codes
  public monthlyInvoiceCount = 0;  // my short codes & billing

  public partnerCount = 0;
  public brandCount = 0; // partner library content brand count.
  public contentProviderCount = 0; // partner library content provider count.

  public static doSums(inst: BadgeData) {
    inst.shortCodeCount = inst.needsActionCount + inst.transfersCount + inst.monthlyInvoiceCount;
    inst.orderCount = inst.needsPaymentCount + inst.monthlyInvoiceCount;
    inst.partnerCount = (inst.brandCount ?? 0) + (inst.contentProviderCount ?? 0);
  }

}

export interface BadgeCountResponse extends IScrBaseResponse {
  data: BadgeData;
}